import { render, staticRenderFns } from "./TemplateFooter.vue?vue&type=template&id=64e3ae72&scoped=true"
import script from "./TemplateFooter.vue?vue&type=script&lang=ts"
export * from "./TemplateFooter.vue?vue&type=script&lang=ts"
import style0 from "./TemplateFooter.vue?vue&type=style&index=0&id=64e3ae72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3ae72",
  null
  
)

export default component.exports